import { useEffect, useState, useRef } from 'react'
import useApp from 'hooks/useApp'
import { useNavigate } from "react-router-dom";
import {
    LayerBottom,
    Button,
  } from "components";


const DataGifLoading = () => {
    const App = useApp()
    const [index, setIndex] = useState(1)
    const titleTextList = ["마이데이터 목록을 불러오고 있어요!","조금만 더 기다려주세요!"]
    
    const [titleText, setTitleText] = useState(titleTextList[0])
    const [seconds, setSeconds] = useState(0)
    const timerRef = useRef(null)
    const [bottomDetailTip, setBottomDetailTip] = useState(false);
    const [retryCount, setRetryCount] = useState(0)
    const openBottomLayer = () => {
        setBottomDetailTip(true);
    };

    const closeBottomLayer = () => {
        setBottomDetailTip(false);
        setSeconds(0)
        setRetryCount(retryCount + 1)
    };

    useEffect(() => {
        App.setHeader({
            show: true,
            title: <></>,
            left:  <></>,
            right: ""
        })

        App.setShowNav(false)
        App.setMainClass("white")

        const interval = setInterval(() => {
            setIndex(prev => (prev % 2) + 1)
        }, 15000)

        return () => clearInterval(interval)
    },[])

    // 1분 타이머
    useEffect(() => {
        timerRef.current = setInterval(() => {
            setSeconds(prev => prev + 1)
        }, 1000)

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current)
            }
        }
    }, [retryCount])

    // 1분 경과 시 이벤트 트리거 및 타이머 정지
    useEffect(() => {
        
        if (seconds >= 60) {
            // 타이머 정지
            if (timerRef.current) {
                clearInterval(timerRef.current)
                timerRef.current = null
            }
            
            openBottomLayer()
        }
    }, [seconds])

    useEffect(() => {
        setTitleText(titleTextList[index-1])
    },[index])

	return (
		<div className="page">
			<div className="padding center-cont mb_100">
                <ul>
                    <li><i className={`icon icon_mydata_loading${index}`} /></li>
					<li>
						
						<h3 className="intro-tit mt_30">{titleText}</h3>
						<p className="intro-sub-tit mt_10">여기서 앱을 종료할 경우<br />
							마이데이터 연결이 중단되오니 주의해주세요.
						</p>
					</li>
				</ul>
			</div>
            <Bottom show={bottomDetailTip} closeLayer={closeBottomLayer} />
		</div>
	)
}

const Bottom = ({ show, closeLayer }) => {
    const navigate = useNavigate()
    return (
      <LayerBottom  
        show={show} 
        closeLayer={closeLayer}
      >
        <div className="layer-text mt_30">
          고객님의 소중한 마이데이터 목록을 불러오고 있어요.<br />
          연동이 완료되면 다시 안내드릴게요.
        </div>
        <div className=' btn-group--inline btn-group  mt_20'>
            <Button className="btn btn--md " onClick={()=>navigate("/")}>모니 구경하기(메인으로 이동)</Button>
        </div>
        
      </LayerBottom>
    );
  };

export default DataGifLoading